import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button, Form, Input } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import TextInput from "../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, inwardFormData } from "./InwardFile";
import {
  dropdownData,
  formatNumber,
  getRecords,
  saveRecords,
  uploadFile,
} from "../../services/api.service";
import { toast } from "react-toastify";
import { TransactionalValidation } from "../../custom/validations/TransactionalValidation";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../custom/components/Asterisks/Asterisks";
import CustomError from "../../custom/components/Errors/CustomError";
import { imageURL } from "../../services/api.service";
import NumberInput from "../../custom/components/Number-Input/NumberInput";
import TextAreaInput from "./../../custom/components/TextArea-Input/TextAreaInput";

const InwardCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
    referenceOptions,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(inwardFormData());
  const [invoiceSelect, setInvoiceSelect] = useState("");
  const [invoiceSelectOptions, setInvoiceSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const delivery_challen_doc_ref = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [filteredItems, setFilteredItems] = useState(
    formData?.inputData?.inward_items || []
  );
  const [fetchedData, setFetchedData] = useState(null);
  const [isFirstInward, setIsFirstInward] = useState(true);
  const [moveToProvision, setMoveToProvision] = useState({});

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    getInvoiceDropData(projectId, null);
  }, []);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      let uniqueIdCounter = 1;
      let moveToProvisionTemp = {}; // Temporary object to store updates

      const updatedInwardItems = data?.inward_items?.map((item) => {
        if (item?.move_to_provision) {
          moveToProvisionTemp[uniqueIdCounter] = true; // Store the value correctly
        }

        return {
          unique_id: uniqueIdCounter++,
          id: item.id,
          item_id: item?.item_id,
          buy_item_id: item?.buy_item_id,
          item_code: item?.makeItem?.item_code,
          make_item_desc: item?.customer_desc,
          make_item_uom: item.makeItem?.uom?.uom_name,
          buy_item_code: item?.buyItem?.item_code,
          description: item?.buyItem?.description,
          uom: item.buyItem?.uom?.uom_name,
          qty: item?.invoice_item_qty,
          remaining_qty: item?.invoice_item_qty,
          shortage_qty: item?.shortage_qty,
          inward_qty: item?.qty,
          provision_qty: item?.provision_qty,
          remarks: item?.remarks,
          is_active: item?.is_active,
          move_to_provision: item?.move_to_provision,
          type: item.is_make_item ? 1 : 2,
        };
      });

      const inwardDocuments =
        data?.inward_documents &&
        data?.inward_documents?.map((item) => ({
          id: item?.id,
          document: item?.document,
          file: item?.file,
          is_active: item?.is_active,
        }));

      setMoveToProvision((prev) => ({
        ...prev,
        ...moveToProvisionTemp, // Update state with all new values
      }));

      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          project_name: data?.project?.project_name,
          order_no: data?.order?.order_no,
          gst_no: data?.order?.gst_no,
          warehouse_name: data?.warehouse?.warehouse_name,
          inward_items: updatedInwardItems,
          inward_documents: inwardDocuments,
        },
      }));
      setFilteredItems(updatedInwardItems);
    }
  }, [fetchedData]);

  const getEditData = async (Id) => {
    try {
      let payload = {
        id: Id,
      };

      const responseData = await getRecords(payload, getEndpoint);
      if (responseData?.code == 1) {
        const data = responseData?.data;
        getInvoiceDropData(data?.project_id, data?.invoice_id);
        setIsFirstInward(false);
        const filteredItems = data?.inward_items?.filter(
          (item) => parseFloat(item?.shortage_qty || 0) > 0
        );
        setFetchedData({ ...data, inward_items: filteredItems });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getInvoiceDropData = async (p_id, i_id) => {
    try {
      let payload = {
        modelName: "invoices",
        whereCondition: {
          project_id: p_id,
          is_invoice_inward_completed: false,
          is_submitted: true,
        },
      };

      const responseData = await getRecords(
        payload,
        "/listInvoiceOrderInCompleted"
      );
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "invoice_no"
        );

        if (id) {
          dropdownResponseData[0].options?.forEach((element) => {
            if (element.value == i_id) {
              setInvoiceSelect(element);
            }
          });
        }
        setInvoiceSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const setInwardData = async (Id) => {
    try {
      let payload = {
        invoice_id: Id,
      };

      const responseData = await getRecords(
        payload,
        "/getInvoicesDetailForInward"
      );
      if (
        responseData?.success == true &&
        responseData.data &&
        responseData.data.length > 0
      ) {
        const selectedData = responseData?.data[0];

        let uniqueIdCounter = 1; // Initialize a counter for unique_id
        const invoiceOrderItems = selectedData?.invoice_order_items
          ?.flatMap((item) => {
            const buyItems = item.buy_item_details?.filter(
              (buyItem) => parseFloat(buyItem?.shortage_qty || 0) > 0
            );
            // Check if the item type is "make item" (type === 1)
            if (item.item?.type === 1 && buyItems?.length > 0) {
              // Transform for each buy_item_details
              return buyItems?.map((buyItem) => ({
                unique_id: uniqueIdCounter++,
                id: undefined,
                invoice_item_id: item.id,
                item_id: item?.item_id,
                buy_item_id: buyItem?.item_id,
                item_code: item?.item?.item_code,
                make_item_desc: item?.customer_desc,
                make_item_uom: item?.item?.uom.uom_name,
                buy_item_code: buyItem.item_data?.item_code,
                description: buyItem?.item_data?.description,
                customer_desc: item?.customer_desc,
                uom: buyItem?.item_data.uom?.uom_name,
                qty: buyItem?.qty,
                remaining_qty: buyItem?.qty,
                shortage_qty: buyItem?.shortage_qty,
                inward_qty: "",
                provision_qty: "",
                is_active: false,
                move_to_provision: false,
                type: item?.item?.type,
              }));
            }

            // If the item is a "buy item" (type === 2), include as-is
            if (
              item.item?.type === 2 &&
              item.buy_item_details?.[0]?.shortage_qty > 0
            ) {
              return {
                unique_id: uniqueIdCounter++,
                invoice_item_id: item.id,
                id: undefined,
                item_id: item?.item_id,
                buy_item_id: item?.item_id,
                item_code: item?.item?.item_code,
                buy_item_code: item?.buy_item_details[0]?.item_data?.item_code,
                description: item?.item?.description,
                customer_desc: item?.customer_desc,
                uom: item.item.uom?.uom_name,
                qty: item?.buy_item_details[0]?.qty,
                remaining_qty: item?.qty,
                shortage_qty: item.buy_item_details[0]?.shortage_qty || 0,
                inward_qty: "",
                provision_qty: "",
                is_active: false,
                move_to_provision: false,
                type: item?.item?.type,
              };
            }
            return null;
          })
          .filter((item) => item !== null);
        setIsFirstInward(selectedData?.is_first_inward);

        // Update the formData state
        setFormData((prevState) => ({
          ...prevState,
          inputData: {
            ...prevState.inputData,
            invoice_id: Id,
            warehouse_name: selectedData?.warehouse?.warehouse_name,
            gst_no: selectedData?.order?.gst_no,
            order_no: selectedData?.order?.order_no,
            project_name: selectedData?.order?.project?.project_name,
            inward_items: invoiceOrderItems,
            project_id: selectedData?.project_id,
            order_id: selectedData?.order_id,
            warehouse_id: selectedData?.warehouse_id,
            contractor_id: selectedData?.order?.contractor_id,
            // remarks: selectedData?.remark,
          },
        }));
        setFilteredItems(invoiceOrderItems);
      } else {
        toast.error(responseData?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = TransactionalValidation(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? true : false) : value,
      },
    }));
  };

  const handleInvoiceSelect = (options) => {
    const selectedValue = options ? options.value : null;
    const fieldError = TransactionalValidation(validationType, {
      invoice_id: selectedValue,
    });

    // Clear outward_items errors
    const updatedErrors = { ...formErrors };
    if (updatedErrors?.inward_items || updatedErrors?.inward_documents) {
      delete updatedErrors.inward_documents;
      delete updatedErrors.inward_items;
    }

    setInvoiceSelect(options);
    setFilteredItems([]);
    if (delivery_challen_doc_ref.current) {
      delivery_challen_doc_ref.current.value = "";
    }
    setInputValue("");
    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        project_id: null,
        order_id: null,
        invoice_id: null,
        warehouse_id: null,
        contractor_id: null,
        inward_date: "",
        delivery_challen_no: "",
        delivery_challen_document: "",
        delivery_challen_document_preview: "",
        remarks: "",
        is_active: true,
        inward_documents: [],
        inward_items: [],
      },
    }));
    setFormErrors({
      ...updatedErrors,
      invoice_id: fieldError?.invoice_id || null,
    });
    setInwardData(selectedValue);
  };

  const handleAddUserDocuments = () => {
    const additionalErrors = {};
    formData?.inputData?.inward_documents?.forEach((row, index) => {
      if (row?.is_active) {
        ["document", "file"].forEach((field) => {
          if (!row[field]?.toString().trim()) {
            additionalErrors.inward_documents = {
              ...additionalErrors.inward_documents,
              [index]: {
                ...additionalErrors.inward_documents?.[index],
                [field]: `${field.replace(/_/g, " ")} is required`,
              },
            };
          }
        });
      }
    });

    if (Object.keys(additionalErrors).length > 0) {
      setFormErrors(additionalErrors);
      return;
    }
    const updatedDocuments = [
      ...formData.inputData.inward_documents,
      { document: "", file: null, preview: "", is_active: true },
    ];
    setFormData({
      ...formData,
      inputData: { ...formData.inputData, inward_documents: updatedDocuments },
    });
  };

  const handleUserDocumentsOnChange = (e, index) => {
    const { name, value } = e.target;
    const updatedDocuments = [...formData.inputData.inward_documents];
    updatedDocuments[index][name] = value;

    let fieldError = "";

    switch (name) {
      case "document":
        if (!value.trim()) {
          fieldError = "document is required";
        }
        break;
      default:
        break;
    }

    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      const documentErrors = { ...updatedErrors.inward_documents };

      if (!documentErrors[index]) {
        documentErrors[index] = {};
      }

      if (fieldError) {
        documentErrors[index][name] = fieldError;
      } else {
        delete documentErrors[index][name];
      }

      if (Object.keys(documentErrors[index]).length === 0) {
        delete documentErrors[index];
      }

      if (Object.keys(documentErrors).length > 0) {
        updatedErrors.inward_documents = documentErrors;
      } else {
        delete updatedErrors.inward_documents;
      }

      return updatedErrors;
    });

    setFormData({
      ...formData,
      inputData: { ...formData.inputData, inward_documents: updatedDocuments },
    });
  };

  const handleUserDocumentFileChange = async (e, index) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      setFormErrors((prev) => ({
        ...prev,
        inward_documents: {
          ...prev.inward_documents,
          [index]: {
            ...prev.inward_documents?.[index],
            file: "Please select a file",
          },
        },
      }));
      return;
    }
    const validTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "application/pdf",
    ];

    const validExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".pdf",
    ];
    const excelExtensions = [".xls", ".xlsx", ".csv"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (excelExtensions.includes(`.${fileExtension}`)) {
    toast.error("Excel files are not allowed. Please upload an image or PDF file.");
    setFormErrors((prev) => ({
      ...prev,
      inward_documents: {
        ...prev.inward_documents,
        [index]: {
          ...prev.inward_documents?.[index],
          file: "Excel files are not allowed",
        },
      },
    }));
    return;
  }

    if (
    !validTypes.includes(selectedFile.type) &&
    !validExtensions.includes(`.${fileExtension}`)
  ) {
    toast.error("Invalid file type. Please upload an image or PDF file");
    setFormErrors((prev) => ({
      ...prev,
      inward_documents: {
        ...prev.inward_documents,
        [index]: {
          ...prev.inward_documents?.[index],
          file: "Invalid file type. Please upload an image or PDF file",
        },
      },
    }));
    return;
  }

    try {
      const response = await uploadFile("uploads", selectedFile);

      if (response?.filePath) {
        setFormData((prevState) => ({
          ...prevState,
          inputData: {
            ...prevState.inputData,
            inward_documents: prevState.inputData.inward_documents.map(
              (doc, i) =>
                i === index
                  ? {
                      ...doc,
                      file: response?.fileName,
                      preview: selectedFile.type.startsWith("image/")
                        ? URL.createObjectURL(selectedFile)
                        : null,
                    }
                  : doc
            ),
          },
        }));

        setFormErrors((prev) => {
          const updated = { ...prev };
          if (updated.inward_documents?.[index]?.file) {
            delete updated.inward_documents[index].file;
            if (Object.keys(updated.inward_documents[index]).length === 0) {
              delete updated.inward_documents[index];
            }
          }
          return updated;
        });
      } else {
        throw new Error("File upload failed");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setFormErrors((prev) => ({
        ...prev,
        inward_documents: {
          ...prev.inward_documents,
          [index]: {
            ...prev.inward_documents?.[index],
            file: error.message || "Error uploading file",
          },
        },
      }));
    }
  };

  const handleRemoveUserDocuments = (index) => {
    const updatedErrors = { ...formErrors };
    delete updatedErrors.inward_documents?.[index];

    setFormData((prev) => {
      const updatedDetails = prev.inputData.inward_documents
        .map((doc, i) => {
          if (i === index) {
            if (doc.id) {
              return { ...doc, is_active: false, percentage: null };
            } else {
              return null;
            }
          }
          return doc;
        })
        .filter((doc) => doc !== null);

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          inward_documents: updatedDetails,
        },
      };
    });

    setFormErrors(updatedErrors);
  };

  const handleItemDetailInputChange = (
    e,
    index,
    field,
    itemCode,
    unique_id
  ) => {
    const { name, value } = e.target;

    const currentItemIndex = formData?.inputData?.inward_items.findIndex(
      (item) => item.unique_id === unique_id
    );
    if (currentItemIndex === -1) return;

    const inwardQty = parseFloat(value);
    const currentItem = formData?.inputData?.inward_items[currentItemIndex];
    currentItem.is_active = false;
    if (name == "inward_qty" || name == "provision_qty" || name == "remarks") {
      if (value) {
        currentItem.is_active = true;
      }
    }
    const isActive = currentItem?.is_active;
    const moveToProvision = currentItem?.move_to_provision;

    let errorMessage = "";
    if (isActive) {
      if (!value) {
        errorMessage = `${name.replace(/_/g, " ")} is required.`;
      } else if (
        moveToProvision &&
        field === "provision_qty" &&
        inwardQty > currentItem?.shortage_qty
      ) {
        errorMessage = `${name.replace(
          /_/g,
          " "
        )} should not be greater than shortage qty.`;
      } else if (
        field === "inward_qty" &&
        inwardQty > currentItem?.shortage_qty
      ) {
        errorMessage = `${name.replace(/_/g, " ")} ${
          isFirstInward
            ? "should not be greater than shortage invoice qty"
            : "should not be greater than shortage qty"
        }`;
      }
    }

    setFormErrors((prev) => {
      const existingErrors = prev.inward_items?.[unique_id] || {};

      if (!moveToProvision && name == "remarks" && !value) {
        existingErrors.inward_qty = "";
      }
      if (name == "inward_qty" && !value) {
        existingErrors.remarks = "";
      }
      // Otherwise, update normally
      return {
        ...prev,
        inward_items: {
          ...prev.inward_items,
          [unique_id]: isActive
            ? {
                ...existingErrors,
                [name]: errorMessage,
              }
            : existingErrors,
        },
      };
    });

    setFormData((prevState) => {
      const updatedDetails = [...prevState.inputData.inward_items];

      // If move_to_provision is true, inward_qty must be 0
      if (currentItem?.move_to_provision) {
        updatedDetails[currentItemIndex].inward_qty = 0;
      } else {
        if (name === "inward_qty") {
          updatedDetails[currentItemIndex].provision_qty = 0;
        }
      }

      updatedDetails[currentItemIndex][name] = value;

      return {
        ...prevState,
        inputData: {
          ...prevState.inputData,
          inward_items: updatedDetails,
        },
      };
    });

    setFilteredItems((prev) =>
      prev.map((item) =>
        item?.unique_id === unique_id
          ? {
              ...item,
              inward_qty: currentItem.move_to_provision ? 0 : item.inward_qty,
              provision_qty: currentItem.move_to_provision
                ? item.provision_qty || ""
                : 0,
              [name]: value,
            }
          : item
      )
    );
  };

  // const handleAccessChange = (e, index, itemCode, unique_id) => {
  //   const updatedErrors = { ...formErrors };
  //   delete updatedErrors?.inward_items?.[unique_id];
  //   const { name, checked } = e.target;

  //   setFormData((prev) => {
  //     const updatedDetails = prev.inputData?.inward_items?.map((item) =>
  //       item?.unique_id === unique_id ? { ...item, [name]: checked } : item
  //     );

  //     return {
  //       ...prev,
  //       inputData: {
  //         ...prev.inputData,
  //         inward_items: updatedDetails,
  //       },
  //     };
  //   });

  //   setFilteredItems((prev) =>
  //     prev.map((item) =>
  //       item.unique_id === unique_id ? { ...item, [name]: checked } : item
  //     )
  //   );
  //   setFormErrors(updatedErrors);
  // };

  const handleMoveTProvisionChange = (e, index, itemCode, unique_id) => {
    const updatedErrors = { ...formErrors };
    delete updatedErrors?.inward_items?.[unique_id];
    const currentItemIndex = formData?.inputData?.inward_items.findIndex(
      (item) => item.unique_id === unique_id
    );
    if (currentItemIndex === -1) return;
    const currentItem = formData?.inputData?.inward_items[currentItemIndex];
    currentItem.is_active = true;

    const { name, checked } = e.target;
    setMoveToProvision((prev) => ({
      ...prev,
      [unique_id]: checked, // Store the value based on index
    }));
    setFormData((prev) => {
      const updatedDetails = prev.inputData?.inward_items?.map((item) =>
        item?.unique_id === unique_id
          ? {
              ...item,
              [name]: checked,
              inward_qty: checked ? 0 : item.inward_qty,
              provision_qty: checked ? item.provision_qty || "" : 0,
            }
          : item
      );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          inward_items: updatedDetails,
        },
      };
    });

    setFilteredItems((prev) =>
      prev.map((item) =>
        item.unique_id === unique_id
          ? {
              ...item,
              [name]: checked,
              inward_qty: checked ? 0 : item.inward_qty,
              provision_qty: checked ? item.provision_qty || "" : 0,
            }
          : item
      )
    );
    setFormErrors(updatedErrors);
  };

  const totalQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.shortage_qty) || 0),
      0
    );

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const submissionType = e?.nativeEvent?.submitter?.name;

      let updatedFormData = { ...formData };
      const additionalErrors = await submitValidation(updatedFormData);

      if (Object.keys(additionalErrors).length > 0) {
        setFormErrors(additionalErrors);
        return;
      }

      const hasActiveInwarddItem =
        updatedFormData?.inputData?.inward_items?.some(
          (item) =>
            Number(item.inward_qty) > 0 || Number(item.provision_qty) > 0
        );

      if (!hasActiveInwarddItem) {
        toast.error(`Please enter a Qty greater than 0 for at least one item.`);
        return;
      }

      let transformedInputData = {
        project_id: updatedFormData?.inputData?.project_id || null,
        order_id: updatedFormData?.inputData?.order_id || null,
        invoice_id: updatedFormData?.inputData?.invoice_id || null,
        warehouse_id: updatedFormData?.inputData?.warehouse_id || null,
        remarks: updatedFormData?.inputData?.remarks || null,
        is_submitted: submissionType === "save" ? false : true,
        created_by: updatedFormData?.inputData?.created_by || 1,
        is_active: true,
        inward_documents:
          updatedFormData?.inputData?.inward_documents?.map((item) => ({
            id: item?.id,
            document: item?.document || null,
            file: item?.file || null,
            is_active: item?.is_active,
          })) || [],
        inward_items:
          updatedFormData?.inputData?.inward_items
            ?.filter((item) => {
              const inwardQty = item?.is_active
                ? parseFloat(item?.inward_qty) || 0
                : 0;
              const provisionQty = parseFloat(item?.provision_qty) || 0;
              return (
                (inwardQty !== 0 &&
                  inwardQty !== "" &&
                  inwardQty !== undefined) ||
                provisionQty > 0
              );
            })
            ?.map((item) => ({
              forceSave: true,
              id: item?.id,
              invoice_item_id: item?.invoice_item_id,
              item_id: item?.item_id,
              is_make_item: item?.type === 1,
              buy_item_id: item?.buy_item_id || null,
              qty: item?.is_active ? parseFloat(item?.inward_qty) || 0 : 0,
              provision_qty: parseFloat(item?.provision_qty),
              shortage_qty: parseFloat(item?.shortage_qty),
              invoice_item_qty: item?.qty || 0,
              referense: item?.reference || null,
              remarks: item?.remarks || "",
              is_active: item?.is_active,
              move_to_provision: item?.move_to_provision,
              customer_desc: item?.customer_desc,
            })) || [],
      };

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const isCreating = !id;

      const updatedInputData = {
        ...transformedInputData,
        created_by: isCreating
          ? userDetails.id
          : updatedFormData.inputData.created_by,
        updated_by: userDetails.id,
      };

      const payload = {
        id: id,
        modelName: initialPayload?.modelName,
        relation: initialPayload?.relation,
        inputData: updatedInputData,
      };

      setLoadingData(true);
      const responseData = await saveRecords(payload, createEndpoint);
      if (responseData && responseData.code == 1) {
        toast.success(`${headerName} saved successfully!`);
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("err", error);
    } finally {
      setLoadingData(false);
    }
  };

  const submitValidation = async (updatedFormData) => {
    const validationErrors = TransactionalValidation(
      validationType,
      formData.inputData
    );
    if (Object.keys(validationErrors).length > 0) {
      setFormErrors(validationErrors);
      return;
    }

    const hasActiveInwardItem = updatedFormData?.inputData?.inward_items?.some(
      (item) => item?.is_active
    );
    if (!hasActiveInwardItem) {
      toast.error("At least one item detail should be enter.");
      return;
    }

    const additionalErrors = {};
    formData?.inputData?.inward_documents?.forEach((row, index) => {
      if (row.is_active) {
        ["document", "file"].forEach((field) => {
          if (!row[field]?.toString().trim()) {
            additionalErrors.inward_documents = {
              ...additionalErrors.inward_documents,
              [index]: {
                ...additionalErrors.inward_documents?.[index],
                [field]: `${field.replace(/_/g, " ")} is required`,
              },
            };
          }
        });
      }
    });

    updatedFormData?.inputData &&
      updatedFormData?.inputData?.inward_items &&
      updatedFormData?.inputData?.inward_items?.forEach((row, index) => {
        if (row?.is_active == true) {
          if (row?.move_to_provision) {
            ["provision_qty", "remarks"].forEach((field) => {
              const fieldValue = row[field]?.toString()?.trim();

              if (!fieldValue) {
                additionalErrors.inward_items = {
                  ...additionalErrors.inward_items,
                  [row?.unique_id]: {
                    ...additionalErrors.inward_items?.[row?.unique_id],
                    [field]: `${field.replace(/_/g, " ")} is required.`,
                  },
                };
              }

              if (
                field === "provision_qty" &&
                parseFloat(fieldValue) > row?.shortage_qty
              ) {
                additionalErrors.inward_items = {
                  ...additionalErrors.inward_items,
                  [row?.unique_id]: {
                    ...additionalErrors.inward_items?.[row?.unique_id],
                    [field]: `${field.replace(
                      /_/g,
                      " "
                    )} should not be greater than invoice qty.`,
                  },
                };
              }
            });
          } else {
            ["inward_qty", "remarks"].forEach((field) => {
              const fieldValue = row[field]?.toString()?.trim();

              if (!fieldValue) {
                additionalErrors.inward_items = {
                  ...additionalErrors.inward_items,
                  [row?.unique_id]: {
                    ...additionalErrors.inward_items?.[row?.unique_id],
                    [field]: `${field.replace(/_/g, " ")} is required.`,
                  },
                };
              }

              if (
                field === "inward_qty" &&
                parseFloat(fieldValue) > row?.shortage_qty
              ) {
                additionalErrors.inward_items = {
                  ...additionalErrors.inward_items,
                  [row?.unique_id]: {
                    ...additionalErrors.inward_items?.[row?.unique_id],
                    [field]: `${field.replace(
                      /_/g,
                      " "
                    )} should not be greater than invoice qty.`,
                  },
                };
              }
            });
          }
        }
      });
    return additionalErrors;
  };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value?.trim() === "") {
      setFilteredItems(formData?.inputData?.inward_items || []);
    } else {
      const filtered = formData?.inputData?.inward_items?.filter((item) =>
        item?.item_code?.toLowerCase()?.includes(value?.toLowerCase())
      );
      setFilteredItems(filtered);
    }
  };

  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  const groupedItems = filteredItems.reduce((acc, item) => {
    if (!acc[item.item_code]) {
      acc[item.item_code] = { makeItem: item, buyItems: [] };
    }

    if (item.buy_item_code) {
      acc[item.item_code].buyItems.push(item);
    }

    return acc;
  }, {});
  let serialNumber = 1;

  return (
    <CustomForm
      title={"CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      noSaveButton={true}
      id={id}
    >
      <Row className="mt-2">
        <Col md="4" className="mt-3">
          <SelectInput
            label="Invoice No"
            value={invoiceSelect}
            options={invoiceSelectOptions}
            onSelect={(selected) => handleInvoiceSelect(selected)}
            placeholder="Select invoice no"
            labelClassName="form-label"
            isClearable={false}
            asterisk={true}
            customError={formErrors?.invoice_id}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="Project name"
            value={formData?.inputData?.project_name}
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="no data found"
            readOnly={true}
            disabled={true}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="SO No"
            value={formData?.inputData?.order_no}
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="no data found"
            readOnly={true}
            disabled={true}
          />
        </Col>
        {id && (
          <Col md="4" className="mt-3">
            <TextInput
              label="Inward No"
              value={formData?.inputData?.inward_no}
              inputClassName="form-control"
              labelClassName="form-label"
              placeholder="no data found"
              readOnly={true}
              disabled={true}
            />
          </Col>
        )}
        <Col md="4" className="mt-3">
          <TextInput
            label="GST No"
            value={formData?.inputData?.gst_no}
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="no data found"
            readOnly={true}
            disabled={true}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="Warehouse"
            value={formData?.inputData?.warehouse_name}
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="no data found"
            readOnly={true}
            disabled={true}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col
          style={{
            marginBottom: "0",
            paddingBottom: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "3px",
          }}
        >
          <h6
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#333",
              backgroundColor: "#f8f9fa",
              padding: "10px 20px",
              borderRadius: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              display: "inline-block",
              margin: "0px",
            }}
          >
            Item Details
          </h6>

          <div>
            <div className="app-search d-flex d-lg-inline mt-0">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control ps-5"
                  placeholder="Search by item code.."
                  value={inputValue}
                  onChange={handleInputChange}
                  style={{
                    width: "13rem",
                    padding: "8px 15px",
                    borderRadius: "8px",
                    borderColor: "#D2D2D2",
                    outline: "none",
                    transition: "all 0.3s ease",
                    boxShadow: "none",
                    marginRight: "0.5rem",
                  }}
                />
                <span className="ri-search-line"></span>
              </div>
            </div>
          </div>
        </Col>
        <div
          className="table mt-2"
          style={{
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "500px",
            width: "100%",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
            msOverflowStyle: "none",
            zIndex: 0,
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>Item Code</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Item Description <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>UOM</th>
                <th style={{ whiteSpace: "nowrap" }}>Invoice QTY</th>
                {!isFirstInward && (
                  <th style={{ whiteSpace: "nowrap" }}>Shortage QTY</th>
                )}

                <th style={{ whiteSpace: "nowrap" }}>
                  Inward QTY <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Remark <Asterisks asterisk={true} />
                </th>
                {/* <th style={{ whiteSpace: "nowrap" }}>Actions</th> */}

                <th
                  colSpan={!moveToProvision[0] && "4"}
                  style={{ whiteSpace: "nowrap" }}
                >
                  Move to Provision
                </th>
              </tr>
            </thead>

            <tbody>
              {Object.values(groupedItems)?.map((group, index) => (
                <React.Fragment key={group.makeItem.unique_id}>
                  {group.makeItem.type == 1 && (
                    <tr
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#f0f8ff",
                      }}
                    >
                      <td>{serialNumber++}</td>
                      <td
                        style={{
                          paddingLeft: "10px",
                          paddingRight: "2px",
                          minWidth: "180px",
                        }}
                      >
                        <div
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                          }}
                          title={group.makeItem.item_code || "N/A"}
                        >
                          {group.makeItem.item_code || "N/A"}
                        </div>
                      </td>
                      <td
                        style={{
                          paddingLeft: "10px",
                          paddingRight: "2px",
                          minWidth: "180px",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                          }}
                          title={group.makeItem.make_item_desc || "N/A"}
                        >
                          {group.makeItem.make_item_desc || "N/A"}
                        </div>
                      </td>
                      <td
                        style={{
                          paddingLeft: "10px",
                          paddingRight: "2px",
                          minWidth: "100px",
                        }}
                      >
                        {" "}
                        {group.makeItem.make_item_uom || "N/A"}
                      </td>
                      <td>{"-"}</td>
                      <td>{"-"}</td>
                      <td colSpan="4">{"-"}</td>
                    </tr>
                  )}

                  {group?.buyItems?.map((row, subIndex) => {
                    if (row.type === 1) {
                      return (
                        <tr
                          key={row.unique_id}
                          style={{ borderBottom: "1px solid #ccc" }}
                        >
                          <td>{`${serialNumber - 1}.${subIndex + 1}`}</td>
                          {/* <td></td> */}
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.buy_item_code || "N/A"}
                            >
                              {row?.buy_item_code || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.description || "N/A"}
                            >
                              {row?.description || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {row?.uom || "N/A"}
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {formatNumber(row?.qty) || 0}
                          </td>
                          {!isFirstInward && (
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "100px",
                              }}
                            >
                              {formatNumber(row?.shortage_qty)}
                            </td>
                          )}

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "115px",
                            }}
                          >
                            <NumberInput
                              name="inward_qty"
                              onChange={(e) =>
                                handleItemDetailInputChange(
                                  e,
                                  subIndex,
                                  "inward_qty",
                                  row?.item_code,
                                  row?.unique_id
                                )
                              }
                              value={
                                row?.move_to_provision === false
                                  ? row?.inward_qty
                                  : 0
                              }
                              disabled={
                                row?.move_to_provision === false ? false : true
                              }
                              inputClassName="form-control"
                              labelStyle={{ display: "none" }}
                              placeholder="Inward QTY"
                              customError={
                                (formErrors?.inward_items &&
                                  formErrors?.inward_items?.[row?.unique_id]
                                    ?.inward_qty) ||
                                ""
                              }
                            />
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "115px",
                            }}
                          >
                            <TextAreaInput
                              name="remarks"
                              onChange={(e) =>
                                handleItemDetailInputChange(
                                  e,
                                  subIndex,
                                  "remarks",
                                  row?.item_code,
                                  row?.unique_id
                                )
                              }
                              value={row?.remarks}
                              inputClassName="form-control"
                              rows={1}
                              cols={1}
                              labelStyle={{ display: "none" }}
                              placeholder="Remark"
                              customError={
                                formErrors?.inward_items?.[row?.unique_id]
                                  ?.remarks || ""
                              }
                            />
                          </td>

                          <td>
                            <CheckboxInput
                              name="move_to_provision"
                              checked={row?.move_to_provision}
                              handleTextChange={(e) =>
                                handleMoveTProvisionChange(
                                  e,
                                  subIndex,
                                  row?.item_code,
                                  row?.unique_id
                                )
                              }
                              checkBoxClassName="form-check-input"
                            />
                          </td>
                          {moveToProvision[row.unique_id] && (
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "135px",
                              }}
                            >
                              <NumberInput
                                name="provision_qty"
                                onChange={(e) =>
                                  handleItemDetailInputChange(
                                    e,
                                    subIndex,
                                    "provision_qty",
                                    row?.item_code,
                                    row?.unique_id
                                  )
                                }
                                value={
                                  row?.move_to_provision === false
                                    ? 0
                                    : row?.provision_qty || ""
                                }
                                disabled={
                                  row?.move_to_provision === false
                                    ? true
                                    : false
                                }
                                inputClassName="form-control"
                                labelStyle={{ display: "none" }}
                                placeholder="Provision QTY"
                                customError={
                                  (formErrors?.inward_items &&
                                    formErrors?.inward_items?.[row?.unique_id]
                                      ?.provision_qty) ||
                                  ""
                                }
                              />
                            </td>
                          )}
                        </tr>
                      );
                    }
                    return null;
                  })}
                </React.Fragment>
              ))}

              {filteredItems
                ?.filter((row) => row.type == 2)
                ?.map((row, index) => (
                  <tr
                    key={row.unique_id}
                    style={{ borderBottom: "1px solid #ccc" }}
                  >
                    <td>{serialNumber++}</td>

                    <td
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "2px",
                        minWidth: "180px",
                      }}
                    >
                      <div
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                        }}
                        title={row?.item_code || "N/A"}
                      >
                        {row?.item_code || "N/A"}
                      </div>
                    </td>

                    <td
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "2px",
                        minWidth: "180px",
                      }}
                    >
                      <div
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                        }}
                        title={row?.description || "N/A"}
                      >
                        {row?.description || "N/A"}
                      </div>
                    </td>

                    <td
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "2px",
                        minWidth: "100px",
                      }}
                    >
                      {row?.uom || "N/A"}
                    </td>
                    <td
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "2px",
                        minWidth: "100px",
                      }}
                    >
                      {isNaN(row?.qty) ? 0 : FloatValue(row?.qty)}
                    </td>
                    {!isFirstInward && (
                      <td
                        style={{
                          paddingLeft: "10px",
                          paddingRight: "2px",
                          minWidth: "100px",
                        }}
                      >
                        {isNaN(row?.shortage_qty) ? 0 : row?.shortage_qty}
                      </td>
                    )}

                    <td
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "2px",
                        minWidth: "115px",
                      }}
                    >
                      <NumberInput
                        name="inward_qty"
                        onChange={(e) =>
                          handleItemDetailInputChange(
                            e,
                            index,
                            "inward_qty",
                            row?.item_code,
                            row?.unique_id
                          )
                        }
                        value={
                          row?.move_to_provision === false ? row?.inward_qty : 0
                        }
                        disabled={
                          row?.move_to_provision === false ? false : true
                        }
                        inputClassName="form-control"
                        labelStyle={{ display: "none" }}
                        placeholder="Inward QTY"
                        customError={
                          (formErrors?.inward_items &&
                            formErrors?.inward_items?.[row?.unique_id]
                              ?.inward_qty) ||
                          ""
                        }
                      />
                    </td>

                    <td
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "2px",
                        minWidth: "110px",
                      }}
                    >
                      <TextAreaInput
                        name="remarks"
                        onChange={(e) =>
                          handleItemDetailInputChange(
                            e,
                            index,
                            "remarks",
                            row?.item_code,
                            row?.unique_id
                          )
                        }
                        value={row?.remarks}
                        inputClassName="form-control"
                        placeholder="Remark"
                        rows={1}
                        cols={1}
                        labelStyle={{ display: "none" }}
                        customError={
                          formErrors?.inward_items?.[row?.unique_id]?.remarks ||
                          ""
                        }
                      />
                    </td>

                    <td>
                      <CheckboxInput
                        name="move_to_provision"
                        checked={row?.move_to_provision}
                        handleTextChange={(e) =>
                          handleMoveTProvisionChange(
                            e,
                            index,
                            row?.item_code,
                            row?.unique_id
                          )
                        }
                        checkBoxClassName="form-check-input"
                      />
                    </td>

                    {moveToProvision[row.unique_id] && (
                      <td
                        style={{
                          paddingLeft: "10px",
                          paddingRight: "2px",
                          minWidth: "135px",
                        }}
                      >
                        <NumberInput
                          name="provision_qty"
                          onChange={(e) =>
                            handleItemDetailInputChange(
                              e,
                              index,
                              "provision_qty",
                              row?.item_code,
                              row?.unique_id
                            )
                          }
                          value={
                            row?.move_to_provision === false
                              ? 0
                              : row?.provision_qty || ""
                          }
                          disabled={
                            row?.move_to_provision === false ? true : false
                          }
                          inputClassName="form-control"
                          labelStyle={{ display: "none" }}
                          placeholder="Provision QTY"
                          customError={
                            (formErrors?.inward_items &&
                              formErrors?.inward_items?.[row?.unique_id]
                                ?.provision_qty) ||
                            ""
                          }
                        />
                      </td>
                    )}
                  </tr>
                ))}

              {totalQty >= 1 && (
                <tr
                  style={{
                    borderTop: "2px solid #cccccc",
                    backgroundColor: "#d9d9d9",
                    fontWeight: "bold",
                    position: "sticky",
                    bottom: 0,
                    zIndex: 40000,
                  }}
                >
                  <td></td>
                  <td>Total</td>
                  <td colSpan="2"></td>
                  {!isFirstInward && <td></td>}
                  <td>{formatNumber(totalQty)}</td>
                  <td colSpan="10"></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Row>

      <Row className="mt-4">
        <Col
          style={{
            marginLeft: "",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBlock: "5px",
            gap: "1rem",
          }}
        >
          <div>
            <h6 className="h-6-heading m-0">Document Details</h6>
          </div>
          <Button
            color="primary"
            className="waves-effect waves-light me-1"
            onClick={handleAddUserDocuments}
            style={{ background: "#006eb9" }}
          >
            Add
          </Button>
        </Col>
        <div
          className="table mt-2"
          style={{
            maxHeight: "450px",
            overflowY: "auto",
            width: "100%",
            scrollbarWidth: "thin",
            scrollBehavior: "smooth",
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Document Name <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Document <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>Preview</th>
                <th style={{ whiteSpace: "nowrap" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {formData?.inputData &&
                formData?.inputData?.inward_documents &&
                formData?.inputData?.inward_documents.map(
                  (item, index) =>
                    item.is_active == true && (
                      <React.Fragment key={index + 1}>
                        <tr
                          style={{
                            borderBottom: "1px solid #cccccc",
                            verticalAlign: "middle",
                          }}
                        >
                          <td>{index + 1}</td>
                          <td>
                            <TextInput
                              name="document"
                              value={item.document}
                              onChange={(e) =>
                                handleUserDocumentsOnChange(e, index)
                              }
                              placeholder="Document"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              asterisk={true}
                              customError={
                                formErrors?.inward_documents?.[index]
                                  ?.document || ""
                              }
                            />
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "110px",
                            }}
                          >
                            <div style={{ position: "relative" }}>
                              <input
                                name="file"
                                type="file"
                                accept="image/*,.pdf,"
                                onChange={(e) =>
                                  handleUserDocumentFileChange(e, index)
                                }
                                className="form-control"
                                style={{
                                  border:
                                    formErrors?.inward_documents?.[index]
                                      ?.file && "1px solid red",
                                  borderColor:
                                    formErrors?.inward_documents?.[index]
                                      ?.file && "#d15757",
                                  boxShadow:
                                    formErrors?.inward_documents?.[index]
                                      ?.file &&
                                    "0px 0px 3px rgba(255, 0, 0, 0.5)",
                                }}
                              />
                              {formErrors?.inward_documents?.[index]?.file && (
                                <i
                                  className="fas fa-exclamation-circle"
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "10px",
                                    transform: "translateY(-50%)",
                                    color: "#d15757",
                                  }}
                                ></i>
                              )}
                            </div>
                            {formErrors?.inward_documents?.[index]?.file && (
                              <CustomError
                                error={
                                  formErrors?.inward_documents?.[index]?.file ||
                                  ""
                                }
                              />
                            )}
                          </td>
                          <td>
                            {item?.file ? (
                              item?.file?.match(/\.(pdf)$/i) ? (
                                <div
                                  onClick={() =>
                                    item.preview
                                      ? window.open(item.preview, "_blank")
                                      : handleImageClick(imageURL + item?.file)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "70px",
                                  }}
                                >
                                  <i
                                    className="far fa-file-pdf"
                                    style={{
                                      fontSize: "36px",
                                      color: "#d32f2f",
                                    }}
                                  ></i>
                                </div>
                              ) : (
                                <img
                                  src={item.preview || imageURL + item?.file}
                                  onClick={() =>
                                    handleImageClick(
                                      item.preview || imageURL + item?.file
                                    )
                                  }
                                  alt="Preview"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    cursor: "pointer",
                                  }}
                                  onError={(e) =>
                                    (e.target.src = "/placeholder.png")
                                  }
                                />
                              )
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100px",
                                }}
                              >
                                <span>No File</span>
                              </div>
                            )}
                          </td>
                          <td>
                            <div
                              onClick={() => handleRemoveUserDocuments(index)}
                            >
                              <Link className="text-danger">
                                <i className="mdi mdi-trash-can font-size-20"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                )}
            </tbody>
          </table>
        </div>
      </Row>
      <Row className="mt-3">
        <Col md="4">
          <TextAreaInput
            label="Remark"
            name="remarks"
            value={formData?.inputData?.remarks}
            onChange={onInputChange}
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="Remark"
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default InwardCreate;
